<template>
  <nav class="navbar navbar-expand-lg">
    <button
      id="navbar-toggler"
      class="navbar-toggler m-auto"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#myNavBar"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation visibility"
    >
      <img src="/assets/hamburger.svg" alt="Toggle navigation visibility" />
    </button>

    <div class="collapse navbar-collapse" id="myNavBar">
      <div class="navbar-nav m-auto">
        <RouterLink to="/" class="nav-item active">Welcome</RouterLink>
        <RouterLink class="nav-item" to="features">Feature Films</RouterLink>
        <RouterLink class="nav-item" to="podcasts">Podcasts</RouterLink>
        <RouterLink class="nav-item" to="about">About</RouterLink>
      </div>
    </div>
  </nav>
</template>

<script setup/>

// All styles set in the user (in this case the banner box)